import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { DepositParams } from './useDepositMutation';

type DepositValidationDTO =
  | {
      canProcessTransfer: true;
      rejectReason: null;
      messageLevel: null;
      note: string;
    }
  | {
      canProcessTransfer: false;
      rejectReason: string;
      messageLevel: 'Error' | 'Warning';
    };

const validateDeposit = async (params: DepositParams): Promise<DepositValidationDTO> =>
  authFetch('/Consumer/AchTransfers/ValidateFund', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });

export const useValidateDepositMutation = () => {
  return useMutation(validateDeposit);
};
